import Parse from 'parse';
import Cookies from 'universal-cookie';
import qs from 'query-string';
import uuid from 'uuid';
import store from 'shared/utils/localStore';
import Promise from 'bluebird';
import { cartRequest } from 'shared/models/cart';
import { trackNow } from 'shared/models/analytic';
import { sanitizeHtml } from 'shared/utils';
import {
  request,
  signupEvent,
  getLoggedInUser,
  thirdPartyAccountLink
} from 'shared/models/api';

import { transferCart, clearCart } from 'components/cart/actions';

import {
  LOAD_LOYALTY_DATA,
  LOYALTY_DATA_LOADING
} from 'components/loyalty/actions';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SIGNUP = 'SIGNUP';
export const LOGIN_SHOW = 'LOGIN_SHOW';
export const ACCOUNT_LINK = 'ACCOUNT_LINK';
export const USER_PHONE_NUMBER = 'USER_PHONE_NUMBER';
export const UPDATE_USER = 'UPDATE_USER';
export const LOGGED_IN_USER_LOADING = 'LOGGED_IN_USER_LOADING';
export const LOGGED_IN_USER_LOADED = 'LOGGED_IN_USER_LOADED';
export const LEAD_CAPTURE_CLOSED = 'LEAD_CAPTURE_CLOSED';

export const LEAD_CAPTURE_CLOSED_AT_KEY = 'scyLeadCaptureClosedAt';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  let user = state.user || action.user;
  let result = {};
  if (user) request.set('x-user', user.id || user.objectId);
  if (user) cartRequest.set('x-user', user.id || user.objectId);
  switch (action.type) {
    case LOGIN:
      if (state.redirect)
        setTimeout(
          () =>
            (window.location =
              window.location.origin + '/' + sanitizeHtml(state.redirect)),
          1
        );
      return {
        ...state,
        user: Object.assign({}, state.user || {}, action.user)
      };
    case LOGOUT:
      return {
        ...state,
        user: null
      };
    case SIGNUP:
      return { ...state, user: action.user };
    case LOGIN_SHOW:
      result = { ...state, display: action.payload.view };
      if (action.payload.redirect) result.redirect = action.payload.redirect;
      return result;
    case USER_PHONE_NUMBER:
      return {
        ...state,
        user: Object.assign({}, state.user || {}, { mobile: action.phone })
      };
    case UPDATE_USER:
      return {
        ...state,
        user: {
          ...user,
          ...action
        }
      };
    case LOGGED_IN_USER_LOADING:
      return {
        ...state,
        loggedInUserLoading: true
      };
    case LOGGED_IN_USER_LOADED:
      return {
        ...state,
        user: action.user,
        loggedInUserLoading: false
      };
    case LEAD_CAPTURE_CLOSED:
      return { ...state, leadCaptureClosedAt: action.time };
    case ACCOUNT_LINK:
      return {
        ...state,
        data: action.data,
        accountLinked: true
      };
    default:
      return state;
  }
}

export function showForgotPassword() {
  return dispatch =>
    dispatch({ type: LOGIN_SHOW, payload: { view: 'forgot' } });
}
export function thirdPartyAuth(data) {
  return dispatch => {
    return thirdPartyAccountLink(data).then(result => {
      dispatch({ type: ACCOUNT_LINK, data: result });
      return result;
    });
  };
}
export function login(data) {
  return dispatch => {
    const username = data.email || data.username;
    const password = data.password;
    return Parse.User.logIn(username, password)
      .then(user => {
        loggedIn(user);
        return dispatch(transferAnonymousUser(user)).then(() => {
          const userData = user.toJSON();
          dispatch({ type: LOGIN, user: userData });
          return userData;
        });
      })
      .catch(({ code, message }) => {
        if (code === Parse.Error.INVALID_SESSION_TOKEN) {
          Parse.User.logOut();
        }
        return Promise.reject(new Error(message));
      });
  };
}

export function fbLoggedIn(user, isSignup = false) {
  return dispatch => {
    loggedIn(user, isSignup);

    let promise = isSignup ? signupEvent() : Promise.resolve();

    return promise
      .catch(err => {
        console.log(err); // eslint-disable-line no-console
      })
      .then(() => dispatch(transferAnonymousUser(user)))
      .then(() => dispatch({ type: LOGIN, user: user.toJSON() }));
  };
}

export function logout() {
  return dispatch => {
    return Parse.User.logOut().then(() => {
      const cookies = new Cookies();
      cookies.remove('user-token', { path: '/' });
      trackNow('Logout');
      dispatch(clearCart());
      anonymousUser();
      dispatch({ type: LOGOUT });
      window.location = '/';
    });
  };
}

export function signup(data) {
  return (dispatch, getState) => {
    const user = new Parse.User();
    user.set('firstname', data.firstname);
    user.set('lastname', data.lastname);
    user.set('username', data.email);
    user.set('password', data.password);
    user.set('email', data.email);
    if (data.gender) user.set('gender', data.gender);
    if (data.mobile) user.set('mobile', data.mobile);
    if (data.stated_source) user.set('stated_source', data.stated_source);
    user.set('birthday', data.birthday);
    user.set('signup_platform', 'web');

    const address = getState().address;
    if (address && address.lat && address.lng) {
      user.set(
        'lastLocation',
        new Parse.GeoPoint({ latitude: address.lat, longitude: address.lng })
      );
    }

    return user
      .signUp()
      .then(user => {
        loggedIn(user, true);
        dispatch(transferAnonymousUser(user));
      })
      .then(() => signupEvent().catch(e => console.log(e))) // eslint-disable-line no-console
      .then(() => {
        const userData = user.toJSON();
        dispatch({ type: SIGNUP, user: { ...userData, orders: [] } });
        return userData;
      });
  };
}

export function showLogin(view, redirect) {
  return dispatch => {
    dispatch({ type: LOGIN_SHOW, payload: { view: view, redirect: redirect } });
    trackNow('Login Modal - ' + view);
  };
}

export function loggedIn(user, signUp = false) {
  if (typeof window === 'undefined') return;
  let id = user.id || user.objectId;
  if (user.firstname === '') user.firstname = ' ';
  if (user.lastname === '') user.lastname = ' ';

  checkParseUser(user);

  try {
    user = user.toJSON ? user.toJSON() : user;
    let name = [user.firstname, user.lastname].join(' ');
    identify(user, signUp);
    window._userId = id;
    window._userName = name;
    window._userEmail = user.email;
  } catch (ex) {
    console.log(ex); // eslint-disable-line no-console
  }
}

function checkParseUser(user) {
  if (typeof window === 'undefined') return;
  const userId = user.id || user.objectId;
  const parseUser = Parse.User.current() || {};
  if (userId !== parseUser.id) {
    const queryParams = qs.parse(window.location.search);
    const sessionToken = queryParams.session;
    if (sessionToken) {
      Parse.User.become(sessionToken);
      delete queryParams.session;
      const queryString = qs.stringify(queryParams);
      const url =
        window.location.pathname + (queryString ? `?${queryString}` : '');
      window.history.replaceState({}, '', url);
    }
  }
}

export function identify(user, isSignup) {
  if (typeof window === 'undefined') return;

  const analytics = window.analytics;
  if (!analytics) return;

  const {
    objectId,
    createdAt,
    email,
    IDFA,
    birthday,
    firstname,
    lastname,
    mobile
  } = user;

  let timezone;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (err) {
    timezone = null;
  }

  let traits = { email };
  if (createdAt) traits.createdAt = createdAt;
  if (timezone) traits.timezone = timezone;
  if (IDFA) traits.IDFA = IDFA;
  if (birthday) {
    traits.birthday = new Date(birthday).toISOString();
    traits.age = Math.floor(
      (new Date() - new Date(birthday)) / (1000 * 60 * 60 * 24 * 365.25)
    );
  }
  if (firstname) traits.firstName = firstname;
  if (lastname) traits.lastName = lastname;
  if (firstname || lastname) {
    traits.name = [firstname, lastname].filter(n => !!n).join(' ');
  }
  if (mobile) traits.phone = mobile;

  if (objectId) {
    analytics.identify(objectId, traits);
  } else if (email) {
    analytics.identify(traits);
  }

  analytics.ready(() => {
    if (objectId) {
      window.branch.setIdentity(objectId, function() {
        if (isSignup) {
          window.branch.track('registration', { parse_id: objectId });
        }
      });
    }
  });
}

export function setPhoneNumber(value) {
  return dispatch => dispatch({ type: USER_PHONE_NUMBER, phone: value });
}

export function anonymousUser() {
  const cookies = new Cookies();
  const userToken = cookies.get('anon-user-token');
  if (userToken === undefined) {
    var token = uuid();
    cookies.set('anon-user-token', token, { path: '/' });
  }
}

function transferAnonymousUser(user) {
  return dispatch => {
    const cookies = new Cookies();
    cookies.set('user-token', user.getSessionToken(), { path: '/' });
    const anonUserToken = cookies.get('anon-user-token');
    if (!anonUserToken) return { type: 'NOOP' };
    return dispatch(transferCart())
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log('error transferring anon user:', err);
      })
      .finally(() => cookies.remove('anon-user-token', { path: '/' }));
  };
}

export function updateUser(params) {
  return dispatch => {
    return Parse.User.current()
      .save(params)
      .then(user => {
        dispatch({ type: UPDATE_USER, ...params });
        return user.toJSON();
      });
  };
}

export function closeLeadCapture() {
  return dispatch => {
    const now = new Date().valueOf();
    store.set(LEAD_CAPTURE_CLOSED_AT_KEY, now);
    dispatch({ type: LEAD_CAPTURE_CLOSED, time: now });
  };
}

export function loadLoggedInUser() {
  return (dispatch, getState) => {
    if (getState().login.loggedInUserLoading) return;
    dispatch({ type: LOGGED_IN_USER_LOADING });
    dispatch({ type: LOYALTY_DATA_LOADING });
    return getLoggedInUser().then(res => {
      if (res && res.user)
        dispatch({ type: LOGGED_IN_USER_LOADED, user: res.user });
      if (res && res.loyalty)
        dispatch({ type: LOAD_LOYALTY_DATA, data: res.loyalty });
    });
  };
}
